import { useTranslation } from '@cx-modules/i18n-provider';

export function useMarketTranslator(sportTranslationFile?: string) {
  const { i18n, t } = useTranslation('bettype');
  const lang = i18n.language;

  return (key: string) => {
    for (const ns of [
      sportTranslationFile ? `bettype_${sportTranslationFile}_outright` : null,
      sportTranslationFile ?? null,
    ]) {
      if (ns && i18n.hasResourceBundle(lang, ns) && i18n.exists(key, { ns })) {
        return t(key, { ns });
      }
    }
    return t(key, { ns: 'bettype' });
  };
}
